import React from "react";
import { Helmet } from "react-helmet-async";

const MetaPixel = () => {
  return (
    <Helmet>
      <script id="facebook-pixel-script">
        {
          `!function(f,b,e,v,n,t,s)
           {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
           n.callMethod.apply(n,arguments):n.queue.push(arguments)};
           if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
           n.queue=[];t=b.createElement(e);t.async=!0;
           t.src=v;s=b.getElementsByTagName(e)[0];
           s.parentNode.insertBefore(t,s)}(window, document,'script',
           'https://connect.facebook.net/en_US/fbevents.js');
           fbq('init', '603189680620499');
           fbq('track', 'PageView');`
        }
      </script>
      <noscript id="facebook-pixel-image">
        {`<img height="1" width="1" style="display:none"src="https://www.facebook.com/tr?id=603189680620499&ev=PageView&noscript=1"/>`}
      </noscript>
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-9795KZ7N7P"></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-9795KZ7N7P');`}
      </script>
      <script>
        {`// Initialize stubs for third-party tracking to prevent GTM errors
          // TossPixel stub
          window.TossPixel = window.TossPixel || function() {
            console.warn('TossPixel called but not loaded yet');
          };
          
          // Google Publisher Tag stub - must be callable and return mock object
          window.googletag = window.googletag || {};
          window.googletag.cmd = window.googletag.cmd || [];
          
          // Create a mock pubads object
          var mockPubads = {
            setTargeting: function() { return this; },
            enableSingleRequest: function() { return this; },
            collapseEmptyDivs: function() { return this; },
            disableInitialLoad: function() { return this; },
            enableVideoAds: function() { return this; },
            setCentering: function() { return this; },
            refresh: function() { return this; },
            clear: function() { return this; },
            addEventListener: function() { return this; },
            removeEventListener: function() { return this; },
            setPrivacySettings: function() { return this; },
            set: function() { return this; },
            get: function() { return null; },
            getSlots: function() { return []; },
            updateCorrelator: function() { return this; }
          };
          
          // Make pubads a function that returns the mock object
          window.googletag.pubads = function() {
            return mockPubads;
          };
          
          // Add other googletag methods
          window.googletag.defineSlot = function() { return mockPubads; };
          window.googletag.display = function() {};
          window.googletag.enableServices = function() {};
          window.googletag.destroySlots = function() { return true; };
          
          // Common tracking array stubs (for various analytics tools)
          window._gaq = window._gaq || [];
          window._paq = window._paq || [];
          window.criteo_q = window.criteo_q || [];
          window.adroll_adv_id = window.adroll_adv_id || '';
          window.adroll_pix_id = window.adroll_pix_id || '';
          window.__adroll = window.__adroll || [];
          
          // Ensure dataLayer exists before GTM loads
          window.dataLayer = window.dataLayer || [];
          
          (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
            'gtm.start':
              new Date().getTime(), event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-P4TG9479');`}
      </script>
    </Helmet>
  );
};

export default MetaPixel;